@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.third_party_transfer.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.third_party_transfer.generated.resources/"

internal val Res.string.feature_tpt_error_amount_invalid: StringResource by lazy {
      StringResource("string:feature_tpt_error_amount_invalid", "feature_tpt_error_amount_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 76),
      ))
    }

internal val Res.string.feature_tpt_error_amount_required: StringResource by lazy {
      StringResource("string:feature_tpt_error_amount_required", "feature_tpt_error_amount_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 87, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87, 65),
      ))
    }

internal val Res.string.feature_tpt_error_remarks_empty: StringResource by lazy {
      StringResource("string:feature_tpt_error_remarks_empty", "feature_tpt_error_remarks_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153, 71),
      ))
    }

internal val Res.string.feature_tpt_error_remarks_invalid: StringResource by lazy {
      StringResource("string:feature_tpt_error_remarks_invalid", "feature_tpt_error_remarks_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 241, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225, 73),
      ))
    }

internal val Res.string.feature_tpt_error_server: StringResource by lazy {
      StringResource("string:feature_tpt_error_server", "feature_tpt_error_server", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 331, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 299, 132),
      ))
    }

internal val Res.string.feature_tpt_label_amount: StringResource by lazy {
      StringResource("string:feature_tpt_label_amount", "feature_tpt_label_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 476, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 432, 40),
      ))
    }

internal val Res.string.feature_tpt_label_destination: StringResource by lazy {
      StringResource("string:feature_tpt_label_destination", "feature_tpt_label_destination", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 517, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 473, 65),
      ))
    }

internal val Res.string.feature_tpt_label_origin_account: StringResource by lazy {
      StringResource("string:feature_tpt_label_origin_account", "feature_tpt_label_origin_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 669, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 625, 60),
      ))
    }

internal val Res.string.feature_tpt_label_origin_account_hint: StringResource by lazy {
      StringResource("string:feature_tpt_label_origin_account_hint", "feature_tpt_label_origin_account_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 575, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 539, 85),
      ))
    }

internal val Res.string.feature_tpt_label_remarks: StringResource by lazy {
      StringResource("string:feature_tpt_label_remarks", "feature_tpt_label_remarks", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 730, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 686, 45),
      ))
    }

internal val Res.string.feature_tpt_tip: StringResource by lazy {
      StringResource("string:feature_tpt_tip", "feature_tpt_tip", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 839, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 67),
      ))
    }

internal val Res.string.feature_tpt_tip_action: StringResource by lazy {
      StringResource("string:feature_tpt_tip_action", "feature_tpt_tip_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 780, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 732, 54),
      ))
    }

internal val Res.string.feature_tpt_transfer_button: StringResource by lazy {
      StringResource("string:feature_tpt_transfer_button", "feature_tpt_transfer_button", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 907, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 855, 55),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_tpt_error_amount_invalid", Res.string.feature_tpt_error_amount_invalid)
  map.put("feature_tpt_error_amount_required", Res.string.feature_tpt_error_amount_required)
  map.put("feature_tpt_error_remarks_empty", Res.string.feature_tpt_error_remarks_empty)
  map.put("feature_tpt_error_remarks_invalid", Res.string.feature_tpt_error_remarks_invalid)
  map.put("feature_tpt_error_server", Res.string.feature_tpt_error_server)
  map.put("feature_tpt_label_amount", Res.string.feature_tpt_label_amount)
  map.put("feature_tpt_label_destination", Res.string.feature_tpt_label_destination)
  map.put("feature_tpt_label_origin_account", Res.string.feature_tpt_label_origin_account)
  map.put("feature_tpt_label_origin_account_hint", Res.string.feature_tpt_label_origin_account_hint)
  map.put("feature_tpt_label_remarks", Res.string.feature_tpt_label_remarks)
  map.put("feature_tpt_tip", Res.string.feature_tpt_tip)
  map.put("feature_tpt_tip_action", Res.string.feature_tpt_tip_action)
  map.put("feature_tpt_transfer_button", Res.string.feature_tpt_transfer_button)
}
